import script from "./AccordionGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionGroup.vue?vue&type=script&setup=true&lang=js"

import "./AccordionGroup.vue?vue&type=style&index=0&id=789dc496&lang=scss"

const __exports__ = script;

export default __exports__